import { post } from "@rails/request.js"
import { Controller } from "stimulus"

export default class extends Controller{

  async checkBoxChangeHandler(event){
    const checkBox = event.target
    const formData = new FormData();
    formData.append("checked", checkBox.checked);

    const response = await post(event.params.url, {body: formData});

    if (!response.ok) {
      checkBox.checked = !checkBox.checked;  // reset checkbox
      const response_data = await response.json;

      // this lovely section of code is to make sure that the checkbox has a chance to repaint with its reverted
      // state prior to the alert message being displayed.  Otherwise it sporadically fails to update until after
      // the alert is dismissed.  https://macarthur.me/posts/when-dom-updates-appear-to-be-asynchronous/
      requestAnimationFrame(() => {   // fires before next repaint
        requestAnimationFrame(() => {  // fires before the _next_ next repaint, which is effectively _after_ the next repaint
          alert(response_data.error || "Unable to update this field. Contact admin for more details.");
        });
      });
    }

  }
}